module.exports = __webpack_public_path__ + "img/coupon_2025.be63542a.png";